module.exports = __webpack_public_path__ + "images/3bf4bd33ffb56c407e8d0ce55c7acc36.jpg";